const development = require(`./development`);
const test = require(`./test`);
const preview = require(`./preview`);
const production = require(`./production`);

function setConfig(config) {
  const domain = window.location.host;
  if (/^localhost/.test(domain) || /^saas.local.qq.com/.test(domain)) {
    config = {
      ...config,
      ...development,
    };
    return config;
  }
  const configs = {
    development,
    test,
    preview,
    production,
  };
  for (const key in configs) {
    if (Object.prototype.hasOwnProperty.call(configs, key)) {
      const configItem = configs[key];
      if (configItem.domain.includes(domain)) {
        config = {
          ...config,
          ...configItem,
        };
        return config;
      }
    }
  }
  config = {
    ...config,
    ...production,
  };
  return config;
}
const commonConfig = {
  apiProduct: 2002,
  //   apiPlatform: 9,
  //   product: 'saas',
  //   company: 'tencent',
  //   api: '/api/access/json',
  //   cloud: '/api/access/pb',
  //   apiList: [], // 非云上接口列表
  //   whiteFilter: ['SendSmsCode', 'Login', 'GetManagerLoginConfig', 'StaffLoginWithWorkwxForManager'],
  //   layoutFilter: ['help', 'login', 'protocol', 'door'],
  //   rightFilter: ['help', 'login', 'protocol', 'register', 'door'],
};
const config = setConfig(commonConfig);
module.exports = config;
